import { useState, useEffect } from 'react';

// TODO: 아래 이미지 URL을 실제 업로드한 이미지로 교체해주세요
const POPUP_IMAGE = 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/3f69e786-9204-4c5e-a6cb-1fa1ba63ac3c_-_-001-6.png?v=b7709824762f154b0dd8ec3e96d7ec02';

const STORAGE_KEY = 'chan_actors_popup_hidden_date';

export default function PopupBanner() {
  const [visible, setVisible] = useState(false);
  const [hideToday, setHideToday] = useState(false);

  useEffect(() => {
    const hiddenDate = localStorage.getItem(STORAGE_KEY);
    const today = new Date().toDateString();
    if (hiddenDate !== today) {
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const handleClose = () => {
    if (hideToday) {
      localStorage.setItem(STORAGE_KEY, new Date().toDateString());
    }
    setVisible(false);
  };

  const handleConsult = () => {
    handleClose();
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-start pl-12"
      style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <div
        className="relative bg-black rounded-2xl overflow-hidden"
        style={{ width: '480px', maxWidth: '90vw' }}
      >
        {/* 닫기 버튼 */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/60 text-white hover:bg-black/90 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg" />
        </button>

        {/* 이미지 영역 */}
        <div className="w-full">
          <img
            src={POPUP_IMAGE}
            alt="찬연기아카데미 이벤트"
            className="w-full h-auto block"
          />
        </div>

        {/* 하단 액션 영역 */}
        <div className="bg-neutral-950 px-6 py-5">
          <button
            onClick={handleConsult}
            className="w-full py-3 rounded-full bg-red-700 hover:bg-red-600 text-white font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap mb-4"
          >
            상담 신청하기 <i className="ri-arrow-right-line ml-1" />
          </button>

          {/* 오늘 하루 보지 않기 */}
          <label className="flex items-center gap-2 cursor-pointer justify-center group">
            <div
              className="w-4 h-4 flex items-center justify-center rounded border border-neutral-600 transition-colors"
              style={{ backgroundColor: hideToday ? '#b91c1c' : 'transparent', borderColor: hideToday ? '#b91c1c' : undefined }}
            >
              {hideToday && <i className="ri-check-line text-white" style={{ fontSize: '10px' }} />}
            </div>
            <input
              type="checkbox"
              className="hidden"
              checked={hideToday}
              onChange={(e) => setHideToday(e.target.checked)}
            />
            <span className="text-neutral-500 text-xs group-hover:text-neutral-300 transition-colors">
              오늘 하루 보지 않기
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}
